import * as Tool from './index';

// 页面跳转
export const pageJumpHandel = (path = '', queryParams = {}) => { // path:页面路由地址 queryParams：跳转传递query参数
  let currentHost = `${window.location.protocol}//${window.location.host}/#`; // 当前域名
  let query = '';
  Object.keys(queryParams).forEach((key, index) => {
    query += `${index ? '&' : ''}${key}=${encodeURIComponent(queryParams[key])}`;
  });
  let linkUrl = path.includes('http') ? path : `${currentHost}${path}${query.length > 0 ? `?` : ''}${query}`;
  let OPEN_LINK_URL = encodeURIComponent(linkUrl);
  if (Tool.webApp.checkAutoHomeApp()) {
    // 主软环境
    window.location.href = `autohome://insidebrowserwk?url=${OPEN_LINK_URL}`;
  } else if (Tool.webApp.checkViolatApp()) { // 违章内
    window.location.href = `wzsdk://wzarticle?url=${OPEN_LINK_URL}`;
  } else { // M
    window.location.href = linkUrl;
  };
};
// pv show 统计
export const trackCustomPageInit = (cate = {}, customVars = {}) => {
  // eslint-disable-next-line
  pvTrack.site = cate.site_id;
  // eslint-disable-next-line
  pvTrack.category = cate.category_id;
  // eslint-disable-next-line
  pvTrack.subcategory = cate.sub_category_id;
  // eslint-disable-next-line
  pvTrack.pageVars = customVars;
  // eslint-disable-next-line
  window._yc_ahas.push(['_trackPageInit']);
  // eslint-disable-next-line
  trackCustomEvent('yc_dynamic_page_show', {
    'bus': '1',
    'page': cate.pageId ? cate.pageId : cate.site_id + '-' + cate.category_id + '-' + cate.sub_category_id,
    'refpage': cate.refpage || '',
    'channel': cate.channel || '0',
    'city': cate.cityId || 110100
  }, customVars);
};

// 操作登录信息
export const handleLogin = (params = {}) => {
  let { successCb = '', failCb = '' } = params;
  if (Tool.webApp.checkViolatApp()) { // 违章
    window.location.href = 'wzsdk://login';
    window.appCallBack = (appParams) => {
      if (appParams.code === 0) {
        successCb && successCb(appParams);
      }
    };
  } else if (Tool.webApp.checkAutoHomeApp()) {
    require('../app/jsBridge');  // eslint-disable-next-line
    window.jsBridge.openLogin({
      success: (result) => {  // 打印客户端返回的参数内容
        if (result.returncode.toString() === '0') {
          successCb && successCb(result);
        }
        log(JSON.stringify(result)); // eslint-disable-line
      },
      fail: (result) => {
        failCb && failCb(result);
        log(JSON.stringify(result)); // eslint-disable-line
      }
    });
  } else if (Tool.webApp.isWxProgram()) {
    // 获取当前url
    let locationUrl = encodeURIComponent(window.location.href);
    // 小程序登录
    wx.miniProgram.navigateTo({ url: `/pages/login/login?url=${locationUrl}` }); // eslint-disable-line
  } else {
    // M 端
    window.location.href = 'https://account.autohome.com.cn/?backurl=' + encodeURIComponent(window.location.href);
  }
};
